// Ranks are earned by catching different satellites, not by repeat sightings.
// Shared by the browser and the server.
export const RANKS = [
  { name: "Initiate", at: 0 },
  { name: "Watcher", at: 1 },
  { name: "Tracker", at: 5 },
  { name: "Hunter", at: 15 },
  { name: "Warden of the Sky", at: 40 },
];

export function rankFor(caught: number) {
  let i = 0;
  while (i + 1 < RANKS.length && caught >= RANKS[i + 1].at) i++;
  return { current: RANKS[i], next: RANKS[i + 1] ?? null };
}

/** The first this many members are founding members. */
export const FOUNDING_PLACES = 100;
/** The full ranking opens once this many members are on the roll. */
export const BOARD_OPENS_AT = 10;
